import { withTranslation } from "react-i18next"
import styled from "styled-components"

const Badge = styled.div`
  cursor: pointer;
  width: 10px;
  height: 10px;
  background: #6b7280;
  outline: ${props => props.active ? '3px solid #ced1d6' : ''};
  border-radius: 50%;
  margin: 7px;
`;

const Badges = (props) => {
  return (
    <div
      style={{ display: 'flex', margin: 'auto', width: 200, justifyContent: 'center', marginBottom: 20, marginTop: 20 }}
    >
      <Badge active={props.active === 1} onClick={() => props.active >= 1 ? props.setCurrentView('picture') : null} />
      <Badge active={props.active === 2} onClick={() => props.active >= 2 ? props.setCurrentView('recipient') : null} />
      <Badge active={props.active === 3} onClick={() => props.active >= 3 ? props.setCurrentView('basket') : null} />
      <Badge active={props.active === 4} />

    </div>
  )
}

export default withTranslation()(Badges)